import React, {useEffect, useState} from 'react'
import {Dropdown, Modal} from 'react-bootstrap'
import {ICandidateVacancyStepItem} from '../../types/candidate/ICandidateVacancyStepItem'
import candidateService, {CandidateVacancyStepType} from '../../api/candidate.api'
import {convertUTCToDatestring} from '../../helpers/convertUTCToDatestring'
import { toast } from 'react-toastify'

type Props = {
  resumeId: number
  vacancyId: number
  updateList: () => void;
}

export const StatusClass = {
  complete: 'text-success',
  failed: 'text-danger',
  isCome: 'text-warning',
  default: 'text-secondary'
};

export const StatusText = {
  complete: 'Пройден',
  failed: 'Не пройден',
  isCome: 'Не пришел',
  default: 'В процессе'
};

const ResumeVacancyStepsModal = (props: Props) => {

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [list, setList] = useState<ICandidateVacancyStepItem[]>([]);

  const update = () => {
    candidateService.getVacancySteps(props.vacancyId, props.resumeId).then((response) => {
      setList(response.data)
    })
  }

  const deleteStepCandidate = async (id: number) => {
    try {
      await candidateService.deleteStepCandidate(id);
      update();
      props.updateList();

      toast.success("Этап кандидата успешно удален!");
    } catch (error) {
      toast.error("Произошла ошибка при удалении этапа кандидата.");
    }
  };

// Функция для изменения статуса этапа кандидата
  const changeStepCandidate = async (id: number, stepType: CandidateVacancyStepType) => {
    try {
      await candidateService.changeStepCandidate(id, stepType);
      update();
      props.updateList();

      toast.success("Статус этапа кандидата успешно обновлен!", {
        autoClose: 1500,
      });
    } catch (error) {
      toast.error("Произошла ошибка при обновлении статуса этапа кандидата.");
    }
  };

  useEffect(() => {
    update()
  }, [props])

  return <>
    <button onClick={(e) => {
      handleShow()
    }} className={`dropdown-item`}>
      Все этапы
    </button>

    <Modal size="xl" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Этапы кандидата</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className='list-group'>
          {
            list && list.length > 0 && list.map((item, index) => {
              const statusKey = item.complete ? 'complete' : item.failed ? 'failed' : item.isCome ? 'isCome' : 'default';

              return <li className="list-group-item" key={index}>
                <div className="d-flex align-items-center justify-content-between">
                  {/* Левая часть */}
                  <div style={{ flexShrink: 0 }}>
                    <small className="fw-500 text-muted">
                      Дата: {item.meetingDate ? convertUTCToDatestring(item.meetingDate) + " " + (item.meetingType ?? '') : "не задана"}
                    </small>
                    <p className="mb-0 fw-bold">{item.step.name}</p>
                  </div>

                  {/* Центральная часть (растягивается) */}
                  <div className="flex-grow-1"></div>

                  {/* Правая часть */}
                  <div className="d-flex align-items-center" style={{ flexShrink: 0 }}>
                    <Dropdown>
                      <Dropdown.Toggle variant="light" size="sm">
                        Изменить статус
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => changeStepCandidate(item.id, CandidateVacancyStepType.complete)}>
                          ✅ Пройден
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => changeStepCandidate(item.id, CandidateVacancyStepType.failed)}>
                          ❌ Не пройден
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => changeStepCandidate(item.id, CandidateVacancyStepType.isCome)}>
                          🚫 Не пришел
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => changeStepCandidate(item.id, CandidateVacancyStepType.isProcess)}>
                          ⏳ В процессе
                        </Dropdown.Item>
                        <Dropdown.Item className="text-danger" onClick={() => deleteStepCandidate(item.id)}>
                          🗑️ <span className="fw-bold">Удалить</span>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    {/* Статус */}
                    <p className={`mb-0 ms-3 w-32 flex justify-end ${StatusClass[statusKey]}`}>
                      {StatusText[statusKey]}
                    </p>
                  </div>
                </div>
              </li>


            })
          }
        </ul>
      </Modal.Body>
    </Modal>
  </>
}

export default ResumeVacancyStepsModal